import {createStore} from 'vuex';
import VuexPersistence from 'vuex-persist';
import accept from './accept';
import account from './account';
import adminIssuerBillingLocalStorage from './admin-issuer-billing-local-storage';
import adminChannelBillingLocalStorage from './admin-channel-billing-local-storage';
import adminSubscriberAccount from './admin-subscriber-account';
import arrivalLocalStorage from './arrival-local-storage';
import damageNoticeLocalStorage from './damage-notice-local-storage';
import departureLocalStorage from './departure-local-storage';
import housekeepingLocalStorage from './housekeeping-local-storage';
import incomeSummaryLocalStorage from './income-summary-local-storage';
import ownerStatementLocalStorage from './owner-statement-local-storage';
import failedTransactionsLocalStorage from './failed-transactions-local-storage';
import category from './category';
import dashboard from './dashboard';
import dictionary from './dictionary';
import digitalSignature from './digital-signature';
import doorLock from './door-lock';
import embeddedPage from './embedded-page';
import header from './header';
import iCalendar from './i-calendar';
import iSettings from './isettings';
import onlineBooking from './online-booking';
import owner from './owner';
import guest from './guest';
import teamMember from './team-member';
import partnerAirbnbColumnsLocalStorage from './partner-airbnb-columns-local-storage';
import partnerAirbnbReviewsLocalStorage from './partner-airbnb-reviews-local-storage';
import partner from './partner';
import paymentGateway from './payment-gateway';
import propertyListLocalStorage from './property-list-local-storage';
import propertyLockout from './property-lockout';
import propertyManager from './property-manager';
import reportFeeServicesLocalStorage from './report-fees-services-local-storage';
import reservation from './reservation';
import reservationsStore from './reservations';
import setupPropertyStore from './setup-property';
import subscription from './subscription';
import stripe from './stripe';
import travelInsurance from './travel-insurance';
import trigger from './trigger';
import website from './website';
import wordpressSettings from './wordpress-settings';
import workOrders from './work-orders';
import seasonality from './seasonality';
import quickbooks from './quickbooks';
import quickbooksOld from './quickbooks_old';

// Vue.use(Vuex);

const vuexLocalStorage = new VuexPersistence({
    key: 'lodgix',
    storage: window.localStorage,
    modules: [
        'adminIssuerBillingLocalStorage',
        'adminChannelBillingLocalStorage',
        'arrivalLocalStorage',
        'damageNoticeLocalStorage',
        'departureLocalStorage',
        'housekeepingLocalStorage',
        'incomeSummaryLocalStorage',
        'ownerStatementLocalStorage',
        'failedTransactionsLocalStorage',
        'partnerAirbnbColumnsLocalStorage',
        'partnerAirbnbReviewsLocalStorage',
        'propertyListLocalStorage',
        'reportFeeServicesLocalStorage',
    ],
});

export default createStore({
    modules: {
        accept,
        account,
        adminIssuerBillingLocalStorage,
        adminChannelBillingLocalStorage,
        adminSubscriberAccount,
        arrivalLocalStorage,
        damageNoticeLocalStorage,
        departureLocalStorage,
        housekeepingLocalStorage,
        incomeSummaryLocalStorage,
        ownerStatementLocalStorage,
        failedTransactionsLocalStorage,
        category,
        dashboard,
        dictionary,
        digitalSignature,
        doorLock,
        embeddedPage,
        iCalendar,
        iSettings,
        header,
        onlineBooking,
        owner,
        guest,
        teamMember,
        partnerAirbnbColumnsLocalStorage,
        partnerAirbnbReviewsLocalStorage,
        partner,
        paymentGateway,
        propertyListLocalStorage,
        propertyLockout,
        propertyManager,
        reportFeeServicesLocalStorage,
        reservation,
        reservationsStore,
        seasonality,
        subscription,
        stripe,
        travelInsurance,
        trigger,
        website,
        workOrders,
        wordpressSettings,
        setupPropertyStore,
        quickbooks,
        quickbooksOld,
    },
    plugins: [vuexLocalStorage.plugin],
});
